/** Tooltip copy for Course Detail table column headers — presentation only. */
export const COURSE_DETAIL_TABLE_HELP = {
  submissions: 'Graded submissions received vs learners assigned to this assessment.',
  avgScore: 'Mean score percentage across all submissions for this assessment.',
  assessmentStatus: 'Live = currently available; Upcoming = scheduled; Closed = past end date or disabled.',
  progress: 'Gradable items this learner has completed, counting both assessments and trainings. An item counts once it is submitted.',
  trainingProgress: 'Trainings this learner has completed out of the trainings attached to this course.',
  latestScore: 'Average score across this learner submitted assessments. Trainings are excluded so the score reflects exams only.',
  learnerStatus: 'Active learners can access the course; inactive learners are blocked.',
};
